import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  IconButton,
  Typography,
  Box,
  Select,
  MenuItem,
  Button,
  Divider,
} from "@mui/material";

import { useForm } from "react-hook-form";
import { WSIcons } from "../../../commonFunctions/iIcons";
import WSTextField, { TextType } from "../../../Components/TextBox/WSTextBox";
import WSPhone from "../../../Components/Phone/WSPhone";
import {
  customValidation,
  validations,
} from "../../../commonFunctions/CommonFunctions";
import WSFileUpload from "../../../Components/FileUpload/WSFileUpload";

interface changepasswordDialogProps {
  open: boolean;
  onClose: () => void;
}

export const ChangePassword: React.FC<changepasswordDialogProps> = ({
  open,
  onClose,
}) => {
  const { register, control } = useForm();

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        fullWidth={true}
        maxWidth="sm"
        PaperProps={{
          style: {
            backgroundColor: "whitesmoke",
            left: 100,
          },
        }}
      >
        <DialogTitle>
          <Grid
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="h6" color="blue">
              User Settings
            </Typography>
            <IconButton onClick={onClose}>
              <WSIcons.CloseIcon sx={{ color: "black" }} />
            </IconButton>
          </Grid>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <WSTextField
                label={"Current Password"}
                {...register("currentpassword")}
                id="currentpassword"
                name="currentpassword"
                control={control}
                rules={{ required: false }}
                labelType="Normal"
              />
            </Grid>
            <Grid item xs={12} >
              <WSTextField
                label={"New Password"}
                {...register("newpassword")}
                id="newpassword"
                name="newpassword"
                control={control}
                rules={{ required: false }}
                labelType="Normal"

              />
            </Grid>
            <Grid item xs={12}>
              <WSTextField
                label={"Verify Password"}
                {...register("verifypassword")}
                id="verifypassword"
                name="verifypassword"
                control={control}
                rules={{ required: false }}
                labelType="Normal"

              />
            </Grid>
          </Grid>
        </DialogContent>
        <Divider />
        <Grid
          item
          sx={{
            padding: "1rem",
            display: "flex", // Enable flexbox layout
            justifyContent: "flex-end", // Align items to the right
            gap: "1rem", // Add spacing between buttons
          }}
        >
          <Button
            variant="outlined"
            sx={{ color: "black", borderColor: "black" }}
          >
            Save
          </Button>
          <Button
            variant="outlined"
            sx={{ color: "black", borderColor: "black" }}
          >
            Close
          </Button>
        </Grid>
      </Dialog>
    </>
  );
};
